import {styled} from "@mui/material/styles"

export const SearchBannerChevronContainer = styled("div")(({theme}) => {
    return {
        gridArea: "end",
        paddingInlineEnd: "1rem",
        textAlign: "right",
        alignSelf: "inherit",
        [theme.breakpoints.up("md")]: {
            padding: "1rem",
        },
    }
})
